/** All avaiable BRS task analytics criterias */
export enum BrsTaskAnalyticsByEnum {
  /** Analytics by company */
  COMPANY = 'COMPANY',
  /** Analytics by direction */
  DIRECTION = 'DIRECTION',
  /** Analytics by unit */
  UNIT = 'UNIT',
  /** Analytics by cost center */
  COST_CENTER = 'COST_CENTER',
  /** Analytics by filial */
  FILIAL = 'FILIAL',
  /** Analytics by deal */
  DEAL = 'DEAL',
}

/** Default criterias */
export const DEFAULT_BRS_TASK_ANALYTICS_BY = Object
  .values(BrsTaskAnalyticsByEnum)
  .filter(item => item !== BrsTaskAnalyticsByEnum.COMPANY);
